import React, { useEffect, useMemo } from 'react'

import { SideFilter } from '_/components/side-filter'

import { FormProvider, useForm } from 'react-hook-form'

import { useToast } from '_/hooks/use-toast'

import moment from 'moment'

import { DatePickerInterval } from '_/components/date-picker-interval'

const TYPE_FILTER = {
  betweenDates: 'between_dates',
}

export const FiltersReport = ({ open, close, applyFilters, filtersField }) => {
  const { showToast } = useToast()

  const methods = useForm({
    mode: 'all',
  })

  const { watch, setValue, errors, register, reset, handleSubmit } = methods

  const handleFilters = data => {
    let filterParams = {}

    filtersField.forEach(filter => {
      if (filter?.filterType === TYPE_FILTER.betweenDates && filter?.report) {
        filterParams = {
          ...filterParams,
          [filter.report]: {
            date_from: moment(data?.[`${filter?.report}-Start`]).startOf('day').format(),
            date_to: moment(data?.[`${filter?.report}-End`]).endOf('day').format(),
          },
        }
      }
    })

    const allRequiredFieldIsNotEmpty = filtersField
      .filter(f => f.isRequired)
      .every(f => String(f.report) in filterParams)

    if (allRequiredFieldIsNotEmpty) {
      applyFilters(filterParams)
      return close()
    }

    return showToast({
      type: 'error',
      message: 'Preencha todos os filtros obrigatórios',
    })
  }

  const handleChange = (value, name) => setValue(name, value)

  const formatDefaultValues = () => {
    filtersField.forEach(filter => {
      if (filter?.filterType === TYPE_FILTER.betweenDates) {
        register(`${filter?.report}-Start`)
        register(`${filter?.report}-End`)
      }
    })
  }

  const resetFilters = () => {
    reset()
    formatDefaultValues()
  }

  useEffect(() => {
    formatDefaultValues()
  }, [filtersField])

  const mainFilters = useMemo(() => {
    return (
      <>
        {filtersField?.map(filterToShow => {
          if (filterToShow?.filterType === TYPE_FILTER.betweenDates) {
            return (
              <DatePickerInterval
                key={filterToShow?.report ?? ''}
                name={`${filterToShow?.report ?? ''}-`}
                label={filterToShow?.label}
                localState={watch()}
                handleChange={handleChange}
                disableFuture={false}
                blackLabel={false}
                firstError={errors?.[`${filterToShow?.report ?? ''}-Start`]?.message}
                secondError={errors?.[`${filterToShow?.report ?? ''}-End`]?.message}
                required={filterToShow?.isRequired}
              />
            )
          }

          return null
        })}
      </>
    )
  }, [{ ...methods }])

  // const moreFilters = useMemo(() => {
  //   return (
  //     <>
  //       {/* <BasicInput
  //         name="classification"
  //         label="Classificação"
  //         placeholder="Classificação"
  //         labelClasses={styles.inputLabel}
  //         style={{ margin: '16px 0 -16px' }}
  //         defaultValue={filters?.classification || ''}
  //       />
  //       <BasicInput
  //         name="noClassification"
  //         label="Sem classificação"
  //         placeholder="Classificação"
  //         labelClasses={styles.inputLabel}
  //         style={{ margin: '16px 0 -16px' }}
  //         defaultValue={filters?.noClassification || ''}
  //       /> */}
  //     </>
  //   )
  // }, [{ ...methods }])

  useEffect(() => {
    formatDefaultValues()
  }, [])

  return (
    <FormProvider {...methods}>
      <SideFilter
        open={open}
        close={close}
        mainFilters={mainFilters}
        // moreFilters={moreFilters}
        cleanFilters={resetFilters}
        applyFilters={handleSubmit(handleFilters)}
      />
    </FormProvider>
  )
}
